export default __webpack_public_path__ + "static/media/logo1.54d13275.svg";